import { v4 as uuidv4 } from 'uuid';

// Resizes image to prevent memory issues with massive files while keeping print quality
export const processFile = (file) => {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      reject(new Error('Invalid file type'));
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        // Max dimension ~3000px to balance quality and memory
        const MAX_DIM = 3000;
        let w = img.width;
        let h = img.height;

        if (w > MAX_DIM || h > MAX_DIM) {
          const ratio = Math.min(MAX_DIM / w, MAX_DIM / h);
          w *= ratio;
          h *= ratio;
        }

        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);

        resolve({
          id: uuidv4(),
          file,
          name: file.name,
          dataUrl: canvas.toDataURL('image/jpeg', 0.85),
          width: w,
          height: h,
          aspectRatio: w / h
        });
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};